/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Manage_TagsInputs */

const cs_clients_manage_tags = /** @type {(inputs: Clients_Manage_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Správa štítků`)
};

const en_clients_manage_tags = /** @type {(inputs: Clients_Manage_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage tags`)
};

/**
* | output |
* | --- |
* | "Manage tags" |
*
* @param {Clients_Manage_TagsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_manage_tags = /** @type {((inputs?: Clients_Manage_TagsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Manage_TagsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_manage_tags(inputs)
	return cs_clients_manage_tags(inputs)
});